import da from '../da';
import VueI18n from 'vue-i18n';

const messages: VueI18n.LocaleMessages = {
  da,
};

export default messages;
